import { Reveal } from "../components/common/Reveal";

const DESCRIPTIONS = {
  conversations: "AI Concierge conversations will appear here once the AI model integration is connected. Architecture is ready — multilingual, guard-railed, WhatsApp handoff.",
  conversions: "Appointment / meeting / order tracking with funnel stages per vertical. Activates with the lead workflow post-launch.",
  revenue: "Revenue attribution by source — organic search, Google Ads, Coffee With Dr. Irma, direct, referral. Fields already exist in every lead record.",
  analytics: "GA4, Search Console and Google Ads intelligence. Connect the IDs in Settings to activate — the event architecture is already in place.",
};

export default function Stub({ area }) {
  return (
    <div data-testid={`admin-stub-${area}`}>
      <p className="eyebrow">{area}</p>
      <h1 className="mt-2 font-serif text-3xl tracking-tight text-ink capitalize">{area}</h1>
      <Reveal>
        <div className="mt-8 max-w-xl border border-ink/10 bg-warmwhite p-8">
          <span className="bg-amber/15 px-2.5 py-1 text-[9px] font-semibold uppercase tracking-[0.15em] text-amber">
            Post-launch activation
          </span>
          <p className="mt-5 text-sm leading-relaxed text-ink/70">{DESCRIPTIONS[area]}</p>
        </div>
      </Reveal>
    </div>
  );
}
